import { Switch,useRouteMatch } from 'react-router';

import AuthenticatedPrivateRoute from '../../AuthenticatedPrivateRoute';
import { ContactManagementProvider } from '../../contexts/ContactManagementContext';
import ApplicationCostDetailPage from '../app-centric/ApplicationCostDetailPage';
import ApplicationDetailPage from '../app-centric/ApplicationDetailPage';
import ApplicationResourcePage from '../app-centric/ApplicationResourcePage';
import DataQualityCreateOrEditRule from '../data-quality/DataQualityCreateOrEditRule';
import AssetPages from './AssetsPages';
import ContactManagement from './contact-mgmt/ContactManagement';
import DashboardPage from './DashboardPage';
import DataCollection from './data-collection/DataCollection';
import DependencyPages from './DependencyPages';
import ImportFromADS from './ImportFromADS';
import ImportFromFile from './ImportFromFile';
import CreateOrEditMainframe from './mainframe/CreateOrEditMainframe';

function PortfolioMgmtPages() {
    const { path } = useRouteMatch();
    
    // TODO: Investigate why DataCollection and Application Detail don't render
    // when excluded from the ContactManagementProvider tag
    return (
        <Switch>
            <AuthenticatedPrivateRoute path={`${path}/dashboard`} component={DashboardPage}/>
            <AuthenticatedPrivateRoute path={`${path}/import-from-ads`} component={ImportFromADS}/>
            <AuthenticatedPrivateRoute path={`${path}/import-from-file`} component={ImportFromFile}/>
            <AuthenticatedPrivateRoute path={`${path}/assets/mainframe/create`} component={CreateOrEditMainframe}/>
            <AuthenticatedPrivateRoute path={`${path}/assets/mainframe/edit/:mainframeId`} component={CreateOrEditMainframe}/>
            <AuthenticatedPrivateRoute path={`${path}/assets/rules/create`} component={DataQualityCreateOrEditRule}/>
            <AuthenticatedPrivateRoute path={`${path}/assets/rules/edit/:ruleId`} component={DataQualityCreateOrEditRule}/>
            <AuthenticatedPrivateRoute path={`${path}/assets`} component={AssetPages}/>
            <AuthenticatedPrivateRoute path={`${path}/dependencies`} component={DependencyPages}/>
            <ContactManagementProvider>
                <AuthenticatedPrivateRoute path={`${path}/contact-management`} component={ContactManagement}/>            
                <AuthenticatedPrivateRoute path={`${path}/data-collection`} component={DataCollection}/> 
                <AuthenticatedPrivateRoute path={`${path}/application-detail/:applicationId/overview`} component={ApplicationDetailPage} />
                <AuthenticatedPrivateRoute path={`${path}/application-detail/:applicationId/resources`} component={ApplicationResourcePage} />
                <AuthenticatedPrivateRoute path={`${path}/application-detail/:applicationId/cost`} component={ApplicationCostDetailPage} />
            </ContactManagementProvider>
        </Switch>
    );
}

export default PortfolioMgmtPages;
